import { connect } from 'react-redux';
import { ActionViewModel } from 'stageclip-common/build/view-models/action-view-model';

import { SimpleModalId } from 'constants/modalId';
import { fetchEmailsLog } from 'api/mails/mails.actions';
import { createModalOpenAction } from 'actions/modalActions';
import { MailerLogTable } from './MailerLogTable';

const mapDispatchToProps = (dispatch: Function): any => ({
  fetchEmailsLog: ({ page, pageSize }: { page: number; pageSize: number }) => dispatch(fetchEmailsLog(page, pageSize)),
  openDetails: (data: ActionViewModel) => dispatch(createModalOpenAction(SimpleModalId.LogDetails, data)),
});

export const MailerLogTableContainer = connect(null, mapDispatchToProps)(MailerLogTable);
